import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import { isDesktop, getLocalStorage } from '@zola-helpers/client';
import { useForceUpdateOnWindowResize } from '@zola/zola-ui';

import { NAV_DATA } from 'constants/navConstants';
import SecondaryNavV2 from 'components/common/header/SecondaryNavV2';

import {
  ConfigureAddressCollectionLinkContainerStateProps,
  ConfigureAddressCollectionLinkContainerDispatchProps,
} from 'components/manage/guestlist/addressCollection/ConfigureAddressCollectionLinkContainer';
import ConfigureAddressCollectionMobileContainer from 'components/manage/guestlist/addressCollection/ConfigureAddressCollectionMobileContainer';
import ConfigureAddressCollectionLinkForm from 'components/manage/guestlist/addressCollection/ConfigureAddressCollectionLinkForm';
import ConfigureAddressCollectionPreview from 'components/manage/guestlist/addressCollection/ConfigureAddressCollectionPreview';

import ConfigureAddressCollectionFormValues from 'components/manage/guestlist/addressCollection/@types/formValues';
import { DISABLED_MODALS } from 'components/manage/guestlist/addressCollection/helpers/disableModal';

import styles from './ConfigureAddressCollectionLinkContainer.module.less';

type ConfigureAddressCollectionLinkProps = ConfigureAddressCollectionLinkContainerStateProps &
  ConfigureAddressCollectionLinkContainerDispatchProps;

const ConfigureAddressCollectionLinkContainer: React.FC<ConfigureAddressCollectionLinkProps> = ({
  formattedFormValues,
  openMagicLinkWelcomeModal,
}) => {
  useForceUpdateOnWindowResize();
  useEffect(() => {
    if (!getLocalStorage(DISABLED_MODALS.MAGIC_LINK_WELCOME)) openMagicLinkWelcomeModal();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const [previewData, setPreviewData] = useState(formattedFormValues);

  const onFormSpy = (data: ConfigureAddressCollectionFormValues): void => setPreviewData(data);

  return (
    <>
      <SecondaryNavV2 activeLinkId={NAV_DATA.SECONDARY.GUEST_LIST.MAGIC_LINK} />
      <div className={styles.container}>
        {isDesktop() ? (
          <div className={cx(styles.contentContainer)}>
            <ConfigureAddressCollectionLinkForm onFormSpy={onFormSpy} />
            <ConfigureAddressCollectionPreview previewData={previewData} />
          </div>
        ) : (
          <ConfigureAddressCollectionMobileContainer
            onFormSpy={onFormSpy}
            previewData={previewData}
          />
        )}
      </div>
    </>
  );
};

export default ConfigureAddressCollectionLinkContainer;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addressCollection/ConfigureAddressCollectionLinkContainer/ConfigureAddressCollectionLinkContainer.tsx